import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var RecentItemsIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsxs("g", {
                        fillRule: "nonzero",
                        children: [
                            _jsx("path", {
                                d: "M16.417 10a6.417 6.417 0 100 12.833 6.417 6.417 0 000-12.833zm0 1.833a4.583 4.583 0 110 9.167 4.583 4.583 0 010-9.167z"
                            }),
                            _jsx("path", {
                                d: "M17.042 13.923c.345 0 .63.255.68.586l.007.102v1.742l1.744.001c.345 0 .63.255.68.586l.007.102c0 .345-.254.63-.586.68l-.101.007h-2.431a.688.688 0 01-.68-.586l-.008-.101V14.61c0-.38.308-.688.688-.688zM14.292 6.73a.688.688 0 01.101 1.367l-.101.007H4.667a.688.688 0 01-.102-1.367l.102-.008h9.625zM10.167 10.854a.688.688 0 01.101 1.368l-.101.007h-5.5a.688.688 0 01-.102-1.367l.102-.008h5.5zM8.104 14.98a.687.687 0 01.102 1.367l-.102.007H4.667a.688.688 0 01-.102-1.367l.102-.008h3.437z"
                            }),
                            _jsx("path", {
                                d: "M13.035 1c.54 0 1.06.19 1.471.535l.149.136 2.633 2.633c.381.382.614.884.661 1.418l.01.201.007 1.264a.917.917 0 01-1.827.107l-.006-.106-.008-1.265a.458.458 0 00-.077-.253l-.057-.07-2.632-2.633a.458.458 0 00-.234-.125l-.09-.009H3.292a.458.458 0 00-.451.376l-.008.083v15.125c0 .225.162.412.376.45l.083.008h4.812a.917.917 0 01.107 1.827l-.107.006H3.292a2.292 2.292 0 01-2.287-2.134L1 18.417V3.292c0-1.213.942-2.206 2.135-2.287L3.292 1h9.743z"
                            })
                        ]
                    })
                })
            })
        ]
    });
};
RecentItemsIcon.isCarinaIcon = true;
export default RecentItemsIcon;
